<template>
  <v-row
    no-gutters
    align="stretch"
    justify="center"
    class="shop-do"
  >
    <v-col cols="12" md="3" lg="2">
      <h2>
        <span>ご予約はこちら</span>
        <v-icon v-if="breakpoint < BREAKPOINT_MD">arrow_downward</v-icon>
        <v-icon v-else>arrow_forward</v-icon>
      </h2>
    </v-col>
    <v-col cols="12" md="9" lg="7">
      <div class="do-buttons" :class="{'size-tablet': breakpoint >= BREAKPOINT_MD}">
        <v-btn text tile exact
          :to="{name: 'cars'}"
        >
          <div class="do-content color-special">
            <v-icon>directions_car</v-icon>
            <span>車種一覧</span>
          </div>
        </v-btn>

        <hr class="hairline">

        <v-btn text tile exact
          :to="{name: 'days'}"
        >
          <div class="do-content color-special">
            <v-icon>event_available</v-icon>
            <span>空き状況を見ながら予約</span>
          </div>
        </v-btn>
      </div>
    </v-col>
  </v-row>
</template>

<style lang="scss">
@import '@/libs/vuetify/styles/variables.scss';

.shop-do {
  h2 {
    @extend %typo-body-1;
    display: flex;
    align-items: center;
    background-color: $key-color;
    color: $title-white-text-color;
    padding: 16px;
    height: 100%;

    > span {
      flex: 1;
    }

    > .v-icon {
      padding: 8px;
      border: solid 2px $title-white-text-color;
      border-radius: 50%;
      color: $title-white-text-color;
    }
  }

  .v-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
  }

  .do-buttons {
    display: flex;
    flex-flow: column;

    hr {
      display: block;
      border: none;
      background-color: $divider-color;

      width: auto;
      height: 1px;
      margin-left: 8px;
      margin-right: 8px;
    }

    .v-btn {
      height: 64px;
    }

    .do-content {
      display: flex;
      flex-flow: row;
      align-items: center;
      text-align: left;
      padding: 8px;

      > span {
        font-size: .75rem;
        margin-left: 16px;
      }

      > .v-icon {
        font-size: 2rem;
      }

      &.color-standard {
        > .v-icon, > span {
          color: $info-darken-color;
        }
      }

      &.color-special {
        > .v-icon, > span {
          color: $specialcar-darken-color;
        }
      }

      &.color-accent {
        > .v-icon, > span {
          color: $accent-darken-color;
        }
      }
    }
  }

  .do-buttons.size-tablet {
    flex-flow: row;
    align-items: center;
    height: 104px;

    hr {
      display: block;
      border: none;
      background-color: $divider-color;

      width: 1px;
      height: 96px - (16px * 2);
      margin-left: auto;
      margin-right: auto;
    }

    .v-btn {
      flex: 1;
      height: 100%;
    }

    .do-content {
      flex-flow: column;
      align-items: center;
      text-align: center;

      > span {
        margin-left: 0;
        margin-top: 12px;
      }
    }
  }
}

</style>

<script>
import PartBase from '@/mixins/PartBase'

export default {
  name: 'ShopDo',
  mixins: [
    PartBase
  ],
  props: {
    profile: {
      type: Object,
      required: true
    }
  }
}
</script>
